/*
 * Which organic motif belongs to which section of the app.
 *
 * Pure: no DOM, no React.
 *
 * sectionKey(pathname)   the first path segment ('' for '/'); query and hash
 *                        are ignored, so they never count as navigation
 * sectionMotif(pathname) 'network' | 'soil' | 'agar' | 'tube' | 'lineage' |
 *                        'genetic' | 'spore'
 * LOADER_ART[motif]      the colony loader drawn for it
 * SWEEP_PATTERN[motif]   the hyphal strip drawn on arrival
 * EMPTY_KIND[motif]      the empty-state scene it suggests
 *
 * The art never encodes data: a motif is a mood for the section, nothing more.
 */

// A Map, not an object literal: a path such as /constructor must not find
// something on Object.prototype.
const BY_SECTION = new Map([
  ['', 'network'],
  ...['collections', 'field', 'survey'].map((s) => [s, 'soil']),
  ...['plates', 'lab', 'scan-station', 'bioreactor', 'experiments', 'protocols'].map((s) => [s, 'agar']),
  ['slants', 'tube'],
  ['strains', 'lineage'],
  ['dna', 'genetic'],
]);

export const LOADER_ART = {
  network: 'network', soil: 'soil', agar: 'agar', tube: 'agar',
  lineage: 'agar', genetic: 'genetic', spore: 'network',
};

export const SWEEP_PATTERN = {
  network: 'branches', soil: 'roots', agar: 'branches', tube: 'branches',
  lineage: 'branches', genetic: 'septate', spore: 'spore',
};

export const EMPTY_KIND = {
  network: 'generic', soil: 'collections', agar: 'plates', tube: 'slants',
  lineage: 'strains', genetic: 'dna', spore: 'generic',
};

export function sectionKey(pathname) {
  const path = String(pathname || '/').split(/[?#]/)[0];
  return path.split('/').filter(Boolean)[0] || '';
}

export function sectionMotif(pathname) {
  return BY_SECTION.get(sectionKey(pathname)) || 'spore';
}
